/* eslint-disable */
import createIcon from '../createIcon';

const IconAdd = createIcon({
  name: 'icon-add',
  content: '<title>ic_添加</title><defs><rect id="icon-add-a" x="0" y="0" width="16" height="16"/></defs><g stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-611.000000, -6456.000000)"><g transform="translate(498.000000, 6169.000000)"><g transform="translate(111.000000, 287.000000)"><g transform="translate(2.000000, 0.000000)"><mask id="icon-add-b" fill="currentColor"><use xlink:href="#icon-add-a"/></mask><use fill="currentColor" opacity="0" xlink:href="#icon-add-a"/><path d="M8.5,1 L8.5,7.5 L15,7.5 L15,8.5 L8.5,8.5 L8.5,15 L7.5,15 L7.5,8.5 L1,8.5 L1,7.5 L7.5,7.5 L7.5,1 L8.5,1 Z" fill="currentColor" fill-rule="nonzero" mask="url(#icon-add-b)"/></g></g></g></g></g>',
  width: 16,
  height: 16
}, 'Icon');
export default IconAdd;
